
import React, { Component } from 'react'

import Axios from 'axios';
import { configuration } from '../../appConfig';
import LazyLoad from 'react-lazyload';

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export default class PrintSlide extends Component {


  state = { selectedPartInfo: [], zoomLevel: 30, division: 2, checked: false, dentCount: 0 }
  getData = async () => {
    const vinNo = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    //const part = this.props.part.split("_")
    const part = this.props.part
    const response = await Axios.get(configuration.GetPartDetails + "?part=" + part+"&vin=" + vinNo + "&partnerId=" + partnerId);
    if (response.data[0]) {
      const str = await response.data[0].json;
      if(str){
        const data = str.split("++++");
        const data1 = await data.filter((row) => {
          return row !== "";
        })
        this.setState({ selectedPartInfo: data1, dentCount: data1.length });
      }
      
    }
  }

  componentDidMount(){
    //this.getData()
  }
partName=(part)=>{
  let partn = part.split("_1");
  return partn[0]
}
  render() {
    const { selectedPartInfo, } = this.state;
    return (
      <div style={{position: "relative"}}>
         {/* <LazyLoad height={200}  once> */}
        
         {/* <div className="textCenter">Part:  {this.partName(this.props.part)}</div> */}
        <img
            alt={this.props.part}
            src={this.props.src}
            // src={'data:image/jpeg;base64,' + this.props.b64text}
            // width="600px"
            // maxHeight: 380,
            className="imgGd"
            style={{  borderRadius: 5,zoom:this.props.zoom+"%",margin:10}}
            onLoad={(e)=>{

            }}
            

          />
          {/* </LazyLoad> */}
           {selectedPartInfo.map((row, i) => {

            const arr = row.split(" ");
            const x = arr[1];
            const y = arr[2];
            const size = arr[3] > 20 ? 50 : 30;
            return (
              <div onClick={() => this.remove(i)} key={i} className="gd" style={{ height: size, width: size, border: arr[3] < 20 && `5px solid #df9207`, top: `${x}px`, left: `${y}px`, zoom: this.props.zoom + "%" }}>
                {/* <span className="textgd">({parseInt(x)},{parseInt(y)})</span> */}
                {/* <button className="deleteBtn">X</button> */}
              </div>)
          })}
      </div>
    )
  }
}




//export default PrintSlide;